import { lazyNamed } from 'src/utils/lazyNamed';

const BidReduction = {
  ModelDashboard: lazyNamed(() => import('./ModelDashboard'), 'ModelDashboard'),
  BidReductionConfigsList: lazyNamed(() => import('./BidReductionConfigsList'), 'BidReductionConfigsList'),
  BidReductionConfigForm: lazyNamed(() => import('./BidReductionConfigForm'), 'BidReductionConfigForm'),
};

export default BidReduction;
